/* eslint-disable react/prefer-stateless-function */
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { extractStylesToArray, isSafe } from "@insite/client-framework/Common/Utilities/isSafeStyles";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLink, getPageLinkByNodeId, LinkModel, mapLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    title = "title",
    // heading = "heading",
    description = "description",
    phoneNumber = "phoneNumber",
    weekDays = "weekDays",
    timings = "timings",
    // changeHeadingColor = "changeHeadingColor",
    // headingAsLink = "headingAsLink",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        // [fields.heading]: string;
        [fields.description]: string;
        [fields.phoneNumber]: string;
        // [fields.changeHeadingColor]: boolean;
        // [fields.headingAsLink]: LinkFieldValue;
    };
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    return {
        linkState: state,
        linkProps: ownProps,
    };
};
export interface ContactUsWidgetStyle {
    titleCss: TypographyProps;
    // headingCss: TypographyProps;
    // changeHeadingColor: TypographyProps;
    description: TypographyProps;
    parentWrapper?: InjectableCss;
}
export const contactUsWidgetStyle: ContactUsWidgetStyle = {
    titleCss: {
        css: css`
            display: block;
            font-size: 21px;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 25px;
            color: #33333a;
            padding-bottom: 8px;
        `,
    },

    // headingCss: {
    //     css: css`
    //         display: block;
    //         font-size: 16px;
    //         font-weight: 500;
    //         letter-spacing: 0;
    //         line-height: 24px;
    //         color: #33333a;
    //     `,
    // },
    // changeHeadingColor: {
    //     css: css`
    //         display: block;
    //         > span {
    //             font-size: 16px;
    //             font-weight: 500;
    //             letter-spacing: 0;
    //             line-height: 24px;
    //             color: #006bc0;
    //         }
    //     `,
    // },
    description: {
        css: css`
            font-size: 16px;
            font-weight: 300;
            letter-spacing: 0;
            line-height: 24px;
            color: #33333a;
        `,
    },
};

const styles = contactUsWidgetStyle;
type Props = OwnProps & ReturnType<typeof mapStateToProps>;

class IntContactUs extends React.Component<Props, any> {
    // eslint-disable-next-line no-useless-constructor
    constructor(props: Props) {
        super(props);
    }

    // openPage = (url: any) => {
    //     if (url) {
    //         const link = getLink(this.props.linkState, url);
    //         if (link && typeof link.url === "string") {
    //             const renderUrl = link?.url;
    //             window.location.href = renderUrl;
    //         }
    //     }
    // };
    componentDidMount() {
        setTimeout(() => {
            if (!window.location.hash) {
                window.location.href = `${window.location.href}#loaded`;
                window.location.reload();
            }
        }, 500);
    }
    render() {
        const fields = this.props.fields;

        return (
            <StyledWrapper {...styles.parentWrapper}>
                <Typography {...styles.titleCss}>{fields?.title}</Typography>
                {/* {!fields?.headingAsLink && (
                    <Typography
                        {...(fields.changeHeadingColor ? { ...styles.changeHeadingColor } : { ...styles.headingCss })}
                    >
                        {fields?.heading}
                    </Typography>
                )} */}
                {/* {fields?.headingAsLink && (
                    <Link
                        {...(fields.changeHeadingColor ? { ...styles.changeHeadingColor } : { ...styles.headingCss })}
                        onClick={() => this.openPage(fields?.headingAsLink)}
                        href=""
                    >
                        {fields?.heading}
                    </Link>
                )} */}

                <Typography {...styles.description}>{parse(fields.description, parserOptions)}</Typography>
            </StyledWrapper>
        );
    }
}

const contactUs: WidgetModule = {
    component: connect(mapStateToProps)(IntContactUs),
    definition: {
        group: "Basic",
        fieldDefinitions: [
            {
                name: fields.title,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 0,
            },
            // {
            //     name: fields.heading,
            //     editorTemplate: "TextField",
            //     defaultValue: "",
            //     fieldType: "Translatable",
            //     sortOrder: 1,
            // },
            // {
            //     name: fields.headingAsLink,
            //     displayName: "Enter Heading link",
            //     editorTemplate: "LinkField",
            //     sortOrder: 2,
            //     defaultValue: { type: "Url", value: "" },
            //     fieldType: "General",
            // },
            {
                name: fields.description,
                displayName: "Description",
                editorTemplate: "RichTextField",
                extendedConfig: { height: 100 },
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 3,
                validate: (html: string) => {
                    const arrayOfStyles = extractStylesToArray(html);
                    return arrayOfStyles?.every(style => isSafe(style))
                        ? null
                        : " The HTML contains invalid styles that prevent it from being saved";
                },
            },
            // {
            //     name: fields.changeHeadingColor,
            //     editorTemplate: "CheckboxField",
            //     defaultValue: false,
            //     fieldType: "General",
            //     sortOrder: 4,
            // },
        ],
    },
};

export default contactUs;
